<template>
  <TheLayout>
    <div class="alert alert-success" role="alert">
      Sie wurden erfolgreich abgemeldet
    </div>
    <button class="btn btn-sm btn-secondary" @click="login">Erneut anmelden</button>
  </TheLayout>
</template>

<script setup>
import { useStore } from "vuex";
import TheLayout from "@/layouts/TheLayout.vue";

const store = useStore();

const login = async () => {
  await store.dispatch("login");
};

</script>

<style scoped>

</style>